// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { N500, N0 } from '@atlaskit/theme/colors';
import { borderRadius, size, center } from '@atlaskit/media-ui';
import { rgba } from '../../styles';
export var CardActionIconButtonVariant = /*#__PURE__*/function (CardActionIconButtonVariant) {
  CardActionIconButtonVariant["default"] = "default";
  CardActionIconButtonVariant["filled"] = "filled";
  return CardActionIconButtonVariant;
}({});
var getVariantStyles = function getVariantStyles(variant) {
  return variant === 'filled' ? "\n    background-color: ".concat("var(--ds-surface-overlay, ".concat(rgba(N0, 0.8), ")"), ";\n\n    &:hover {\n      background-color: ", "var(--ds-surface-overlay-hovered, ".concat(rgba(N0, 0.6), ")"), "\n    }\n  ") : "\n    &:hover {\n      background-color: ".concat("var(--ds-background-neutral-subtle-hovered, rgba(9, 30, 66, 0.06))", ";\n    }\n  ");
};
export var cardActionButtonStyles = function cardActionButtonStyles(_ref) {
  var variant = _ref.variant;
  return css({
    appearance: 'none',
    border: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  center,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  borderRadius,
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  size(26), {
    color: "var(--ds-icon, ".concat(N500, ")"),
    '&:hover': {
      cursor: 'pointer'
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  getVariantStyles(variant));
};